angular.module('common.directives').directive('recordingVideo', function () {
  return {
    scope: {
      recordingData: '=',
      closeVideo: '='
    },
    templateUrl: './templates/recordingVideo.view.html?t=' + window.webpackHash,
    link: function ($scope, $element) {},
    controller: 'recordingVideoController'
  }
})
